import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CLazy',
  setup(__props) {

const lazyComponent = ref<HTMLElement | null>(null);
const isVisible = ref(false);

onMounted(() => {
    try {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    isVisible.value = true;
                    observer.disconnect();
                }
            });
        });
        if (lazyComponent.value) {
            observer.observe(lazyComponent.value);
        }
    } catch (error) {
        console.error(error);
        isVisible.value = true;
    }
});

return { __sfc: true,lazyComponent, isVisible }
}

})